/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2023-10-25 11:19:18
 * @LastEditors: sueRimn
 * @LastEditTime: 2024-10-10 14:43:31
 */
export const SENTRY_DSN = {
  '10.10.75.137': 'http://c671b8a98dd0464993050fc93d127479@10.10.75.137:9001/4',
  'presys.5ycap.com': 'https://a8188b506e1a4113bc61eb42b7748a5d@presys.5ycap.com/3',
  'sys.5ycap.com': 'https://e67faba2de944788bcc063754ef76b2d@sys.5ycap.com/5'
}

export const AppEnvMap = {
  dev: {
    domain: 'presysld',
    key: 'devwuyuan'
  },
  test: {
    domain: 'presysld',
    key: 'testwuyuan'
  },
  pre: {
    domain: 'presysld',
    key: 'prewuyuan'
  },
  prod: {
    domain: 'sysld',
    key: 'wuyuan'
  }
}
export const WebSocketConfig = {
  local: {
    url: 'ws://192.168.58.199:10104/ws/audio_ai'
  },
  dev: {
    url: 'wss://10.10.45.52:18090/ws/audio_ai'
  },
  test: {
    url: 'wss://10.10.75.137:18090/ws/audio_ai'
  },
  pre: {
    url: 'wss://presys.5ycap.com/ws/audio_ai'
  },
  prod: {
    url: 'wss://sys.5ycap.com/ws/audio_ai'
  }
}
export const SystemVersion = 'V1.56.0'
